import React from 'react';
import { Box } from '@material-ui/core';
import { CloseOutlined } from '@material-ui/icons';
import {
  bool, func, number, string,
} from 'prop-types';
import completedIcon from '../assets/completed_I.svg';

const CompletedBanner = ({
  count, show, label, setCompletedShow, onClick, undoText,
}) => (
  <Box style={{
    position: 'absolute',
    top: 86,
    left: 6,
    width: 'calc(100% - 12px)',
    height: '92px',
    padding: '12px 12px 18px',
    background: '#1A8282',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
    display: show ? 'unset' : 'none',
  }}
  >
    <Box style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}
    >
      <Box style={{
        display: 'flex',
        alignItems: 'center',
      }}
      >
        <img src={completedIcon} alt="completed-icon" />
        <Box style={{
          marginLeft: 12,
          fontFamily: 'Montserrat',
          fontWeight: 500,
          fontSize: 14,
          lineHeight: '18px',
          color: '#ffffff',
        }}
        >
          {`${count} ${label}`}
        </Box>
      </Box>
      <CloseOutlined
        style={{ color: '#ffffff', cursor: 'pointer' }}
        onClick={() => setCompletedShow()}
      />
    </Box>
    <Box
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingRight: '24px',
        marginTop: 18,
      }}
      onClick={onClick}
    >
      <span style={{
        fontFamily: 'Montserrat',
        fontWeight: 700,
        fontSize: 16,
        lineHeight: '20px',
        color: '#ffffff',
        cursor: 'pointer',
      }}
      >
        {undoText}
      </span>
    </Box>
  </Box>
);

CompletedBanner.propTypes = {
  count: number,
  show: bool,
  label: string,
  setCompletedShow: func,
  onClick: func,
  undoText: string,
};

export default CompletedBanner;
